import type { CSSProperties } from 'react';

/** 기본 터치 영역 한 변 */
export const DEFAULT_TOUCH_TARGET_PX = 48;
/** 막대 가로 상한 기본값 */
export const DEFAULT_MAX_BAR_WIDTH_PX = 32;

const TOUCH_TARGET_MIN_PX = 12;
const TOUCH_TARGET_MAX_PX = 96;

/**
 * 막대 최소 가로(px). `TOUCH_TARGET_MIN_PX`와 동일하게 둠.
 * 더 크게 잡으면 `touchTargetClampedPx === TOUCH_TARGET_MIN_PX`일 때 `barInsetLeft`가 음수가 될 수 있음.
 */
const BAR_WIDTH_MIN_PX = TOUCH_TARGET_MIN_PX;

/** 세 줄 막대 사이 세로 간격 비율 */
const BAR_SPACE = 0.5;

/** 막대 가로÷세로 비율 (막대를 가로 12 단위로 볼 때 세로 1 단위) */
const BAR_WIDTH_TO_HEIGHT_RATIO = 12;

/** 소수 px를 과도한 자릿수 없이 문자열화 — 작은 치수에서 round 누적 왜곡 완화 */
const toPx = (value: number) => `${Number(value.toFixed(3))}px`;

/**
 * 토글 막대 위치/크기 CSS 변수 계산.
 * MenuToggleButton, MenuToggleIcon에서 공유.
 */
export function computeMenuToggleVars(touchTargetPx: number, maxBarWidthPx: number): CSSProperties {
  const touchTargetClampedPx = Math.min(TOUCH_TARGET_MAX_PX, Math.max(TOUCH_TARGET_MIN_PX, touchTargetPx));
  const barWidthPx = Math.max(BAR_WIDTH_MIN_PX, Math.min(touchTargetClampedPx, maxBarWidthPx));
  const barHeightPx = barWidthPx / BAR_WIDTH_TO_HEIGHT_RATIO;
  const barGapPx = barWidthPx / (3 * (BAR_SPACE + 1));
  const barRowStridePx = barHeightPx + barGapPx;
  const barsStackHeightPx = 3 * barHeightPx + 2 * barGapPx;
  const stackInsetTopPx = (touchTargetClampedPx - barsStackHeightPx) / 2;
  const barInsetLeftPx = (touchTargetClampedPx - barWidthPx) / 2;

  return {
    '--mtb-touch-target': toPx(touchTargetClampedPx),
    '--mtb-bar-width': toPx(barWidthPx),
    '--mtb-bar-height': toPx(barHeightPx),
    '--mtb-bar-inset-left': toPx(barInsetLeftPx),
    '--mtb-stack-inset-top': toPx(stackInsetTopPx),
    '--mtb-bar-row-stride': toPx(barRowStridePx),
  } as CSSProperties;
}
